import { FeatureCategory } from '../types';

export const activitiesFeatures: FeatureCategory = {
  name: "Activities & Enrichment",
  icon: "Gamepad2",
  features: [
    { 
      name: "Fitness Videos", 
      description: "Access to guided fitness videos designed for seniors, including chair exercises, gentle yoga, and balance training.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Activity Logging", 
      description: "Track daily activities, exercise, hobbies, and social engagement to monitor overall wellness and activity levels.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Brain Games", 
      description: "Cognitive exercises and brain training games designed to maintain mental sharpness and memory.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Hobbies & Interests", 
      description: "Explore and track personal hobbies and interests with resources, communities, and activity suggestions.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Plants & Gardening Hub", 
      description: "Comprehensive gardening resources, plant care guides, and seasonal gardening activities for indoor and outdoor spaces.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Book Explorer", 
      description: "Discover new books, track reading progress, and access book recommendations tailored to your interests.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    }
  ]
};
